import { Box } from '@material-ui/core';
import { Tooltip, Typography } from '@mui/material';
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { showCurrency } from '../dashboard/Dashboard';
import { getClassName } from '../demat/Holdings';

const calculateUnrealizedProfitWrtMarketHolding = (unrealizedProfit, marketHolding) => {
    const result = (unrealizedProfit * 100) / marketHolding
    if (isNaN(result) || !isFinite(result))
        return 0
    return result.toFixed(2)
}

const calculateRealizedProfitWrtMarketHoldingAndCash = (realizedProfit, marketHolding, availableCash) => {
    const result = (realizedProfit * 100) / (marketHolding + availableCash)
    if (isNaN(result) || !isFinite(result))
        return 0
    return result.toFixed(2)
}

const columns = [
    { field: 'fullName', headerName: 'Full name', width: 140 },
    { field: 'broker', headerName: 'Broker', width: 100, valueGetter: ({ row }) => row?.broker?.replace('_', ' ') },
    { field: 'unrealizedProfit', headerName: 'Unrealized profit (₹)', width: 140, type: 'number', valueFormatter: value => showCurrency(value?.value, false) },
    { field: 'realizedProfit', headerName: 'Realized profit (₹)', width: 140, type: 'number', valueFormatter: value => showCurrency(value?.value, false) },
    { field: 'marketHolding', headerName: 'Market Holding (₹)', width: 140, type: 'number', valueFormatter: value => showCurrency(value?.value, false) },
    { field: 'availableCash', headerName: 'Available Cash (₹)', width: 140, type: 'number', valueFormatter: value => showCurrency(value?.value, false) },
    {
        field: 'unrealizedProfitWrtMarketHolding', headerName: 'Unrealized Profit wrt. Market Holding (%)',
        width: 140, type: 'number', valueGetter: ({ row }) => calculateUnrealizedProfitWrtMarketHolding(row?.unrealizedProfit, row?.marketHolding)
    },
    {
        field: 'realizedProfitWrtMarketHolding', headerName: 'Realized Profit wrt. Market Holding + Cash (%)',
        width: 140, type: 'number', valueGetter: ({ row }) => calculateRealizedProfitWrtMarketHoldingAndCash(row?.realizedProfit, row?.marketHolding, row?.availableCash)
    },
    {
        field: 'under20SMASymbols', headerName: 'Under 20 SMA open trades',
        width: 140, type: 'number', valueGetter: ({ row }) => row?.under20SMASymbolsCsv?.split?.(',')?.length,
        renderCell: ({ row }) => row && row?.under20SMASymbolsCsv && <Tooltip title={row?.under20SMASymbolsCsv}>
            {row?.under20SMASymbolsCsv?.split?.(',')?.length || 0}
        </Tooltip>
    },
    {
        field: 'under50SMASymbols', headerName: 'Under 50 SMA open trades',
        width: 140, type: 'number', valueGetter: ({ row }) => row?.under50SMASymbolsCsv?.split?.(',')?.length,
        renderCell: ({ row }) => row && row?.under50SMASymbolsCsv && <Tooltip title={row?.under50SMASymbolsCsv}>
            {row?.under50SMASymbolsCsv?.split?.(',')?.length || 0}
        </Tooltip>
    },
];


export const UsersSummary = ({ user }) => {
    const [usersSummary, setUsersSummary] = useState()

    useEffect(() => {
        fetch('/algo-trading/api/admin/users-summary', {
            headers: new Headers({
                'Authorization': user?.credential
            }),
        }).then(r => {
            if (r.status >= 400) {
                return
            }
            r.text()
                .then(value => {
                    setUsersSummary(JSON.parse(value));
                })
        }
        ).catch(error => {
            console.log(error);
        });

        return () => setUsersSummary()
    }, [user])

    if (!usersSummary)
        return null

    return (
        <Box
            sx={{
                '& .profit': {
                    color: 'green',
                },
                '& .loss': {
                    color: 'red',
                },
                '& .negative': {
                    backgroundColor: 'rgba(157, 255, 118, 0.49)',
                    color: '#1a3e72',
                    fontWeight: '600',
                },
                '& .positive': {
                    backgroundColor: '#d47483',
                    color: '#1a3e72',
                    fontWeight: '600',
                },
            }}
        >
            <DataGrid
                slots={{
                    toolbar: () => <GridToolbarContainer style={{ justifyContent: 'space-around' }}>
                        <Typography variant='h5' align='center'>Users Summary</Typography>
                        <GridToolbarColumnsButton />
                        <GridToolbarFilterButton />
                        <GridToolbarDensitySelector />
                        <GridToolbarExport />
                        <GridToolbarQuickFilter />
                    </GridToolbarContainer>
                }}
                columns={columns}
                rows={usersSummary || []}
                getRowId={row => row?.id}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                    },
                }}
                pageSizeOptions={[10, 20, 30, 40]}
                autoHeight={true}
                getCellClassName={(params) => {
                    if (params?.colDef?.type != 'number') return ''
                    return getClassName(params, params?.field)
                }}
            />
        </Box>
    )
}
